// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.g9EsX9 {
  position: relative;
  display: inline-block;
}

.d8AoHc {
  position: fixed;
  min-width: 193px;
  background: var(--surface-neutral-white);
  border: 1px solid var(--stroke-neutral-subtle);
  border-radius: var(--radius-s);
  box-shadow: var(--shadow-sm);
  padding: var(--spacing-1);
  z-index: 1000;
  overflow: hidden;
  animation: URNvzy 0.2s ease-out;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
}

.tz4pjC {
  display: flex;
  align-items: center;
  width: 100%;
  padding: var(--spacing-1);
  border: none;
  background: none;
  font-size: var(--font-size-md);
  font-weight: var(--font-weight-regular);
  color: var(--text-neutral-dark);
  font-family: var(--font-family-base);
  text-align: left;
  cursor: pointer;
  transition: background-color 0.15s ease;
  gap: var(--spacing-1);
  line-height: var(--line-height-180);
  white-space: nowrap;
}

.tz4pjC:hover:not(:disabled) {
  background-color: var(--surface-neutral-subtle);
  border-radius: var(--radius-s);
}

.tz4pjC:disabled {
  cursor: not-allowed;
  opacity: 0.6;
  color: var(--text-neutral-medium);
}

.y7yzge {
  color: var(--status-error);
}

.GYaYVp {
  width: 12px !important;
  height: 12px !important;
}

@keyframes URNvzy {
  from {
    opacity: 0;
    transform: translateY(-4px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
`, "",{"version":3,"sources":["webpack://./../../packages/shared-ui/src/components/ButtonOptions/ButtonOptions.module.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,wCAAwC;EACxC,8CAA8C;EAC9C,8BAA8B;EAC9B,4BAA4B;EAC5B,yBAAyB;EACzB,aAAa;EACb,gBAAgB;EAChB,+BAA2C;EAC3C,aAAa;EACb,sBAAsB;EACtB,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,yBAAyB;EACzB,YAAY;EACZ,gBAAgB;EAChB,8BAA8B;EAC9B,uCAAuC;EACvC,+BAA+B;EAC/B,oCAAoC;EACpC,gBAAgB;EAChB,eAAe;EACf,uCAAuC;EACvC,qBAAqB;EACrB,mCAAmC;EACnC,mBAAmB;AACrB;;AAEA;EACE,+CAA+C;EAC/C,8BAA8B;AAChC;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,iCAAiC;AACnC;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,sBAAsB;EACtB,uBAAuB;AACzB;;AAEA;EACE;IACE,UAAU;IACV,2BAA2B;EAC7B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF","sourcesContent":[".container {\n  position: relative;\n  display: inline-block;\n}\n\n.popover {\n  position: fixed;\n  min-width: 193px;\n  background: var(--surface-neutral-white);\n  border: 1px solid var(--stroke-neutral-subtle);\n  border-radius: var(--radius-s);\n  box-shadow: var(--shadow-sm);\n  padding: var(--spacing-1);\n  z-index: 1000;\n  overflow: hidden;\n  animation: buttonOptionsSlide 0.2s ease-out;\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n}\n\n.action {\n  display: flex;\n  align-items: center;\n  width: 100%;\n  padding: var(--spacing-1);\n  border: none;\n  background: none;\n  font-size: var(--font-size-md);\n  font-weight: var(--font-weight-regular);\n  color: var(--text-neutral-dark);\n  font-family: var(--font-family-base);\n  text-align: left;\n  cursor: pointer;\n  transition: background-color 0.15s ease;\n  gap: var(--spacing-1);\n  line-height: var(--line-height-180);\n  white-space: nowrap;\n}\n\n.action:hover:not(:disabled) {\n  background-color: var(--surface-neutral-subtle);\n  border-radius: var(--radius-s);\n}\n\n.action:disabled {\n  cursor: not-allowed;\n  opacity: 0.6;\n  color: var(--text-neutral-medium);\n}\n\n.actionDestructive {\n  color: var(--status-error);\n}\n\n.actionDestructiveIcon {\n  width: 12px !important;\n  height: 12px !important;\n}\n\n@keyframes buttonOptionsSlide {\n  from {\n    opacity: 0;\n    transform: translateY(-4px);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `g9EsX9`,
	"popover": `d8AoHc`,
	"buttonOptionsSlide": `URNvzy`,
	"action": `tz4pjC`,
	"actionDestructive": `y7yzge`,
	"actionDestructiveIcon": `GYaYVp`
};
module.exports = ___CSS_LOADER_EXPORT___;
